import {ZoneType} from "./zoneDeptRelation";

export class EPCSequenceThing {
  SerialSequence: string;
  Group: string;
  EncodedEPC: string;
  WriteTime: number;

  constructor(SerialSequence: string,
              EncodedEPC: string,
              WriteTime: number,
              Group: string) {
    this.SerialSequence = SerialSequence;
    this.EncodedEPC = EncodedEPC;
    this.WriteTime = WriteTime;
    this.Group = Group;
  }
}



// WEBPACK FOOTER //
// ./src/models/EPCSequenceThing.ts